import { Link } from "react-router-dom";
import aboutImg from "../../assets/images/luudu_sneakers.jpg";

export const About = () => {
  return (
    <main className="about_layout my-0 -!mt-[2.5rem] md:mt-0 md:my-10 px-4 sm:px-6 lg:px-8">
      <div className="about_layout_content">
        <h2 className="web_heading bar_above mb-4 text-xl sm:text-2xl md:text-3xl lg:text-4xl">
          About us
        </h2>
        <p className="web_paragraph_1 mt-2 text-sm sm:text-base md:text-lg">
          At Luudu, we&apos;re redefining how people buy footwear by  
          combining collective purchasing power. Our platform
          transforms individual demand into coordinated group campaigns
          to optimize pricing unlocking access to high-quality products
          at significantly lower costs. Our goal is to pass on savings 
          to our consumers by cutting out middle men.
        </p>
      </div>
    </main>
  );
};
